// Hide / Show fixed addcart button on mobile
var stickyButton = document.querySelector("#addcart-sticky");
var waypoint1 = new Waypoint({
  element: document.getElementById('product-intro'),
  handler: function(direction) {
    if (direction == 'down') { stickyButton.classList.add("show") }
    else { stickyButton.classList.remove("show") }
  },
  offset: 'bottom-in-view'
});

// updated to hit top of recommended products 
var waypoint2 = new Waypoint({
  element: document.getElementById('recommended-products'),
  handler: function(direction) {
    if (direction == 'down') { stickyButton.classList.remove("show") }
    else { stickyButton.classList.add("show") }
  },
  offset: '100%'
});

// Add scrolled-to class to scroll containers for animation

var waypoint3 = new Waypoint({
  element: document.getElementById('product-features-container'),
  handler: function() {
    scrollAnimate(this.element)
    this.destroy()
  },
  offset: 'bottom-in-view'
});


// Animated text section when scrolled to
function scrollAnimate(container) {
  var promise = Promise.resolve();
  
  var array = container.querySelectorAll('.scroll-container');
  var interval = 600; // how much time should the delay between two iterations be (in milliseconds)?
  array.forEach(function (el, index) {
    promise = promise.then(function () {
      el.classList.add("scrolled-to","loading");
      if (index > 0 ) el.previousElementSibling.classList.remove("loading");
      return new Promise(function (resolve) {
        setTimeout(resolve, interval);
      });
    });
  });

  promise.then(function () {
    document.getElementById('product-features-container').querySelector('.scroll-container:last-of-type').classList.remove("loading")
    
    // setTimeout(el.classList.remove("loading"), interval); 
  });
}
